const calpak = window.calpak

window.calpak.timers.deferredLoaded = performance.now().toFixed(0)
document.dispatchEvent(new Event("calpak:ready"))
console.log('calpak:ready');
